module.exports = __webpack_public_path__ + "static/media/osf.dbde5c31.png";